import { citizenAddress, liveCollection, materials } from './collectes'
import type { CitizenRequest } from './demandes'

/** Requête ouverte par ATNA quand un bac n'a pas été ramassé. */
export const binRequestReference = '#REQ-2947'

export const binRequest: CitizenRequest = {
  id: 'req-2947',
  reference: binRequestReference,
  title: `Bac non ramassé — ${materials[liveCollection.material].label}`,
  service: 'Matières résiduelles',
  category: 'Collecte au chemin',
  address: citizenAddress,
  fullAddress: `${citizenAddress}, Québec, G0H 1A0`,
  submittedOn: 'Envoyée aujourd’hui',
  createdOn: '18/09/26',
  resolvedOn: null,
  createdBy: 'ATNA',
  status: 'recue',
  description: `Le bac de ${materials[liveCollection.material].label.toLowerCase()} n’a pas été ramassé lors de la collecte du jour (${liveCollection.sector}, ${liveCollection.truck}). Le bac est resté en bordure du chemin.`,
  attachments: [],
  timeline: [
    { date: 'Aujourd’hui', label: 'Requête ouverte par ATNA' },
    { date: 'Aujourd’hui', label: 'Transmise au service de la voirie' },
  ],
  messages: [
    {
      id: 'msg-2947-1',
      author: 'ville',
      authorName: 'Matières résiduelles',
      sentAt: 'Aujourd’hui',
      body: 'Merci pour votre signalement. Un rattrapage est prévu dans les 48 heures ouvrables. Laissez votre bac en bordure du chemin d’ici là.',
    },
  ],
}
